import { createContext, useState, ReactNode } from 'react';

export type UserContectProviderProps = {
  children: ReactNode;
};

export type UserInfoType = {
  id?: string;
  username?: string;
};

export type UserContextType = {
  userInfo: UserInfoType | null;
  setUserInfo: React.Dispatch<React.SetStateAction<UserInfoType | null>>;
};

export const UserContext = createContext<UserContextType>({ userInfo: null, setUserInfo: () => {} });

export const UserContextProvider = ({ children }: UserContectProviderProps) => {
  const [userInfo, setUserInfo] = useState<UserInfoType | null>({});

  return <UserContext.Provider value={{ userInfo, setUserInfo }}>{children}</UserContext.Provider>;
};
